<script>
  export let name;
  export let size = "inherit";
  export let color = undefined;
  export let cursor = "inherit";
  export let selected = false;
  export let tooltip = false;
</script>

<article class:tooltip data-tooltip={tooltip}>
  {#if color}
    <i
      aria-hidden="true"
      style="font-size:{size}px; color:{color}; cursor:{cursor};"
      class="fas fa-{name}"
      class:selected
      on:click />
  {:else}
    <i
      aria-hidden="true"
      style="font-size:{size}px; cursor:{cursor};"
      class="fas fa-{name}"
      class:selected
      on:click />
  {/if}
</article>

<style>
  i.selected {
    color: white;
  }
  i {
    color: var(--primary-light-color);
  }
</style>
